import React from 'react';

export const C = {
  bg: '#FDFBF7', cream: '#F5F0E8', card: '#FFFFFF', border: '#E8E3DB',
  borderLight: '#F0EBE3', text: '#1A1A18', textSec: '#6A6560', muted: '#9A9590',
  accent: '#C67A5C', green: '#5A8C6A', greenBg: '#EBF3EE', gold: '#C6A05C',
  goldBg: '#FFF8ED', purple: '#7B6B9E', black: '#1A1A18',
};

export const GREETINGS = {
  morning: 'Good morning',
  afternoon: 'Good afternoon',
  evening: 'Good evening',
  night: 'Good night',
};

export const SectionLabel = ({ children }) => (
  <p style={{ fontSize: 11, letterSpacing: '0.8px', color: C.muted, fontFamily: 'var(--font-sans)', textTransform: 'uppercase', margin: '0 0 12px', fontWeight: 500 }}>{children}</p>
);

export const Pill = ({ children, onClick, accent }) => (
  <button onClick={onClick} style={{
    display: 'inline-block', padding: '8px 16px', borderRadius: 20,
    fontSize: 13, fontFamily: 'var(--font-sans)', cursor: 'pointer', border: 'none',
    background: accent ? C.accent : C.cream, color: accent ? '#FFF' : C.textSec,
    fontWeight: 500, transition: 'all 0.2s',
  }}>{children}</button>
);

export const API = '/api';
